import React, { PropTypes } from 'react';
import { pure } from 'recompose';

const DiffusionItem = props => {
  const { user } = props;
  return (
    <tr>
      <td>{user.email}</td>
      <td>{user.first_name}</td>
      <td>{user.last_name}</td>
    </tr>
  );
};

DiffusionItem.propTypes = {
  user: PropTypes.object.isRequired,
};

export default pure(DiffusionItem);



// WEBPACK FOOTER //
// ./src/modules/messaging/components/DiffusionItem.js